import { Branch } from '../../../types/branch';
import { ReservationTypeWithColor } from '../../../hooks/AppData/useReservationTypes';

export const getBranchFromId = (id: string | undefined, branches: Branch[] | undefined) => {
  if (!id || !branches) return;
  return branches.find((_) => _.id === id);
};

export const getBranchReservationTypes = (
  branchId: string | undefined,
  reservationTypes: ReservationTypeWithColor[] | undefined,
) => {
  if (!branchId) return;
  return reservationTypes?.filter((_) => _.branchId === branchId);
};
